require("bootstrap-fileinput");
require("bootstrap-fileinput/js/locales/fr");
require("./theme-uil.js");

export default class AbstractFileInput extends HTMLDivElement {

    $fileinput;
    pluginData;

    constructor() {
        super();
        this.$fileinput = $(this.getFileInput());
        this.pluginData = this.getBaseConfig();
    }

    connectedCallback() {
        this.setEvents();
        this.setPlugin(this.pluginData);
    }

    setPlugin() {
        this.$fileinput.fileinput(this.pluginData);
    }

    setEvents() {
        this.$fileinput.on('drop', function (e) {
            if (e.originalEvent.dataTransfer) {
                if (e.originalEvent.dataTransfer.files.length) {
                    // Stop the propagation of the event
                    e.preventDefault();
                    e.stopPropagation();
                    // Main function to upload
                    $(this)[0].files = e.originalEvent.dataTransfer.files;
                }
            }
        });

        this.$fileinput.on('filecleared', function (event) {
            if ($(this).data('js-required') == 'required') {
                $(this).attr('required', 'required');
            }
        });

        $('body').on('click', 'button.fileinput-remove, button.kv-file-remove', function () {
            var $formgroup = $(this).parents('.form-group');
            var $input = $('<input/>', {
                name: $formgroup.data('field') + '-removed',
                type: 'hidden',
                value: 1
            });
            $(this).parents('form').append($input);
        });
    }

    getFileInput() {
        return this.querySelector('input');
    }

    getBaseConfig() {
        var data = {
            theme: this.getTheme(),
            language: this.getLang(),
            showCaption: false,
            showUpload: false,
            showDrag: false,
            allowedFileTypes: this.getAllowedFileTypes(),
            allowedFileExtensions: this.getAllowedFileExtensions(),
            fileTypeSettings: this.getFileTypeSettings(),
            fileActionSettings: this.getFileActionSettings(),
            initialPreviewShowDelete: false
        };

        if (this.$fileinput.data('show-remove') == 'false') {
            data.showRemove = false;
            data.fileActionSettings.showRemove = false;
        }

        return data;
    }

    getTheme() {
        return 'uil';
    }

    getLang() {
        return 'fr';
    }

    getAllowedFileTypes() {
        return [];
    }

    getAllowedFileExtensions() {
        if (this.$fileinput.data('allowed-format')) {
            return this.$fileinput.data('allowed-format');
        }

        return [];
    }

    getFileTypeSettings() {
        return {};
    }

    getFileActionSettings() {
        return {
            showRemove: false,
            showUpload: false, // will be always false for resumable uploads
            showDownload: false,
            showZoom: false,
            showDrag: false,
        };
    }
}
